import { useState } from "react";
import { motion } from "framer-motion";
import { Play, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { WHACK_LEVELS } from "@/utils/whackGameData";

const WhackGameSettings = ({ onStartGame, onBack }) => {
  const [selectedLevel, setSelectedLevel] = useState(null); // null = all levels

  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className="glass-card-strong rounded-xl p-5 sm:p-7 border border-gold/20 shadow-lg w-full max-w-2xl mx-auto"
      data-testid="whack-game-settings"
    >
      <div className="flex items-center justify-center gap-2 mb-2">
        <Zap className="w-7 h-7 text-white" />
        <h2 className="font-fredoka text-xl sm:text-2xl text-white">Pukul Jawaban!</h2>
      </div>
      <p className="font-fredoka text-gold-light/80 text-sm text-center mb-5">
        Pukul jawaban yang benar sebelum menghilang!
      </p>

      {/* Mode Selection */}
      <div className="mb-5">
        <label className="font-fredoka text-gold-light/80 text-sm mb-2 block">Pilih Mode</label>
        <div className="grid grid-cols-2 gap-2">
          <Button
            data-testid="whack-mode-all"
            variant={selectedLevel === null ? "default" : "outline"}
            onClick={() => setSelectedLevel(null)}
            className={`font-fredoka py-3 h-auto ${
              selectedLevel === null ? "bg-gradient-to-r from-yellow-400 to-amber-500 text-brown-dark" : "border-gold/20 text-gold hover:bg-gold/10"
            }`}
          >
            <Zap className="w-4 h-4 mr-1.5" />
            Semua Level
          </Button>
          {WHACK_LEVELS.map((lvl) => (
            <Button
              key={lvl.id}
              data-testid={`whack-mode-${lvl.id}`}
              variant={selectedLevel === lvl.id ? "default" : "outline"}
              onClick={() => setSelectedLevel(lvl.id)}
              className={`font-fredoka py-3 h-auto ${
                selectedLevel === lvl.id ? "text-brown-dark" : "border-gold/20 text-gold hover:bg-gold/10"
              }`}
              style={selectedLevel === lvl.id ? { background: lvl.color, boxShadow: `0 0 12px ${lvl.color}40` } : {}}
            >
              <span className="mr-1.5">{lvl.icon}</span>
              {lvl.name}
            </Button>
          ))}
        </div>
      </div>

      {/* Level info */}
      <div className="mb-5 p-3 rounded-lg border border-gold/20 glass-card text-center">
        <p className="font-fredoka text-gold-light/80 text-xs">
          {selectedLevel === null
            ? "Mainkan semua 6 level berurutan! Semakin tinggi level, semakin seru!"
            : `${WHACK_LEVELS.find(l => l.id === selectedLevel)?.questions.length || 5} pertanyaan - Badge: ${WHACK_LEVELS.find(l => l.id === selectedLevel)?.badge}`
          }
        </p>
      </div>

      <Button
        onClick={() => onStartGame(selectedLevel)}
        className="w-full font-fredoka font-bold uppercase tracking-wide text-brown-dark bg-gradient-to-r from-yellow-400 to-amber-500 hover:bg-gradient-to-r from-yellow-400 to-amber-500/90"
        style={{ boxShadow: '0 0 20px rgba(255,215,0,0.4)' }}
        data-testid="whack-start-btn"
      >
        <Play className="w-5 h-5 mr-2" />
        Main Cepat!
      </Button>

      <Button onClick={onBack} variant="ghost" className="w-full mt-2 text-gold hover:bg-gold/10 font-fredoka text-sm">
        Kembali ke Menu Utama
      </Button>
    </motion.div>
  );
};

export default WhackGameSettings;
